import { adminSearchUsersRequest, higherEdAdminSearchManagersRequest } from '@uplift/api';
import { UserRole } from '@uplift/types';

export const useUserSearch = (isHigherEdAdminRole: boolean) =>
  async (term: string) => {
    let response;

    if (isHigherEdAdminRole) {
      response = await higherEdAdminSearchManagersRequest({ search_phrase: term });
    } else {
      response = await adminSearchUsersRequest({ search_phrase: term });
    }

    const result = response.users.map(user => ({
      id: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      preferredName: (user.preferredName && user.role === UserRole.externalAdmin) ? user.preferredName : '', // don't show preferred name for org managers
      active: user.active,
      adminRole: user.adminRole,
      role: user.role,
    }));

    return result;
  };
